import { Directive, DoCheck, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { startWithFactory } from '@platform-frontend/util';
import { filter, take, takeUntil, tap } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[formGroup][yatSubmit]'
})
export class SubmitDirective implements DoCheck {
  constructor(private formGroup: FormGroupDirective) {}

  @Input()
  submitDisabledForm: boolean = false;

  @Output()
  yatSubmit = new EventEmitter<any>();

  @Output()
  submitTried = new EventEmitter<null>();

  @Output()
  submitDenied = new EventEmitter<null>();

  @HostBinding('class.was-validated')
  submittedState = false;

  ngDoCheck(): void {
    if (this.submittedState !== this.formGroup.submitted) {
      this.submittedState = this.formGroup.submitted;
    }
  }

  @HostListener('submit')
  submit(): void {
    this.formGroup.form.markAllAsTouched();
    this.submitTried.emit();
    this.submitAfterValidation();
  }

  private submitAfterValidation(): void {
    const formValue = this.formGroup.value;
    this.formGroup.statusChanges
      ?.pipe(
        startWithFactory(() => this.formGroup.status),
        filter(status => status !== 'PENDING'),
        take(1),
        tap(() => (this.formGroup.valid || (this.formGroup.disabled && this.submitDisabledForm) ? this.yatSubmit.emit(formValue) : this.submitDenied.emit())),
        takeUntil(this.submitTried),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
